import _ from 'underscore';

import Barcode from 'react-barcode';  // https://github.com/lindell/JsBarcode/wiki/Options
import { DEFAULT_BACKGROUND_COLOR, VerticalSeparator, HorizontalSeparator } from './utils';

export const variantMap = {
    'CR Member': 'cr',
    'CR SuperStar': 'ss',
    'Cool Rewards Junior': 'jr',
    'Family Ambassador': 'fa',
}

export const MEMBERSHIP_TIERS = Object.keys(variantMap);

export function MembershipCardImage({ tierCode, height, width, addDropShadow = false }) {
    let variant = variantMap[tierCode] || 'cr';
    const styles = _.extend(
        {
            maxWidth: '300px',
            maxHeight: '194px',
        },
        addDropShadow ? { filter: 'drop-shadow(3px -2px 3px)'} : {},
        !!height ? { height } : {},
        !!width ? { width } : {},
    )
    return (
        <img
            alt={`Cool Rewards ${variant.toUpperCase()}`} src={`cool-rewards-${variant}.png`}
            style={styles}
        />
    );
}

export function MembershipCardWide({ name = 'Member', tierCode = 'CR Member', cardId = '00000000', bgColor = DEFAULT_BACKGROUND_COLOR }) {
    return (
        <div className='telegram-app-row'>
            <div className='flex-justify-center'>
                <div className='membership-card-container-wide'>
                    <MembershipCardImage tierCode={tierCode} addDropShadow={false} />
                    <p>{name}</p>
                </div>
            </div>
            <VerticalSeparator height='5px'/>
            <div className='flex-justify-center'>
                <div className='barcode-container-wide'>
                    <Barcode height={50} value={cardId} text={`Card ID: ${cardId}`} fontSize={12} background={bgColor}/>
                </div>
            </div>
        </div>
    );
}

export function MembershipCardRow({ name = 'Member', tierCode = 'CR Member', cardId = '00000000', bgColor = DEFAULT_BACKGROUND_COLOR }) {
    return (
        <div className='telegram-app-row'>
            <div className='horizontal-flex'>
                <div className='membership-card-container'>
                    <MembershipCardImage width='calc(300px * 0.4)' height='calc(194px * 0.4)' tierCode={tierCode} addDropShadow={false} />
                </div>
                <HorizontalSeparator width='10px'/>
                <div className='barcode-container'>
                    <Barcode width={2.4} height={50} value={cardId} text={`Card ID: ${cardId}`} fontSize={12} background={bgColor}/>
                </div>
            </div>
            <p className="app-text">
                <strong>{name}</strong>
            </p>
        </div>
    );
}

export default MembershipCardWide;